// @ts-strict-ignore
import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Popover } from '@usealloy/component-library';
import type { BaseDocumentUploadProps } from './DocumentUploadContent';
import { DocumentUploadContent } from './DocumentUploadContent';


/**
 * Props for DocumentUploadPopover.
 * Extends BaseDocumentUploadProps with popover-specific props (trigger, positioning, etc.).
 */
interface DocumentUploadPopoverProps extends BaseDocumentUploadProps {
  isOpen: boolean;
  onClose: () => void;
  onUpload: () => void;
  trigger: React.ReactNode;
  align?: 'start' | 'end' | 'center';
  side?: 'top' | 'right' | 'bottom' | 'left';
  title?: string;
}

/**
 * Popover wrapper for document upload functionality.
 * Designed to be used inline within other components (e.g., DocumentReviewModal).
 * Uses the Popover component from the component library for positioning.
 */
export const DocumentUploadPopover = ({
  caseToken,
  documentTypes,
  entities,
  evaluationToken,
  investigationToken,
  isOpen,
  onClose,
  onUpload,
  trigger,
  align = 'start',
  side = 'bottom',
  title,
}: DocumentUploadPopoverProps) => {
  const handleUploadComplete = () => {
    onUpload();
    onClose();
  };

  return (
    // @ts-expect-error - DndProvider typing issue
    <DndProvider backend={HTML5Backend}>
      <Popover
        isOpen={isOpen}
        onOpenChange={open => {
          if (!open) {
            onClose();
          }
        }}
        trigger={trigger}
        align={align}
        side={side}
        style={{
          maxWidth: '500px',
          width: '500px',
        }}
      >
        <div
          style={{
            maxHeight: '450px',
            overflowY: 'auto',
            padding: 'var(--cl-space-4)',
            width: '100%',
            boxSizing: 'border-box',
          }}
        >
          <DocumentUploadContent
            caseToken={caseToken}
            documentTypes={documentTypes}
            entities={entities}
            evaluationToken={evaluationToken}
            investigationToken={investigationToken}
            onUploadComplete={handleUploadComplete}
            onCancel={onClose}
            showCancelButton
            showUploadButton
            title={title}
            showDescription={false}
          />
        </div>
      </Popover>
    </DndProvider>
  );
};
